import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import {
  ReprocessAttendanceData,
  RequestReprocessAttendanceDto,
  ResponseAttendanceTempDto,
  RequestAttendanceTempDto,
} from "../dto/attendances.dto";
import { ResponseData } from "../../nest-responses";
import { RequestRecordTimeGdDto, RequestRecordTimeBarcodeGdDto, ResponseGetButtonBreakTime } from "../dto/attendance.dto";

@Injectable()
export class AttendancesApi {

  private readonly service: string = '';
  private readonly model: string = 'attendances';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public reprocessAttendance(payload: RequestReprocessAttendanceDto): Observable<ResponseData<ReprocessAttendanceData[]>> {
    const method: string = 'POST';
    const func: string = 'reprocessAttendance';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ReprocessAttendanceData[]>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public getAttendanceTemp(payload: RequestAttendanceTempDto): Observable<ResponseData<ResponseAttendanceTempDto[]>> {
    const method: string = 'POST';
    const func: string = 'getAttendanceTemp';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseAttendanceTempDto[]>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public getNewTodayAttendance(payload: RequestAttendanceTempDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'getNewTodayAttendance';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000, null, true);
  }

  public getBreakButton(): Observable<ResponseData<ResponseGetButtonBreakTime>> {
    const method: string = 'GET';
    const func: string = 'getBreakButtonNew';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public getBreakButtonAcr(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getBreakButtonAcr';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public recordTimeBreak(payload: RequestRecordTimeGdDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'recordTimeBreakNew';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }

  public qrCodeTimeBreak(payload: RequestRecordTimeBarcodeGdDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'qrCodeTimeBreak';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, (5 * 60) * 1000);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendances.api.ts